import type { Example } from '../types';

export const meshClonesExample: Example = {
  id: 'mesh-clones',
  title: 'Instant Mesh Cloning',
  categoryId: 'viewer',
  description: 'clone_ref() + clone() — many copies, zero extra WASM cost',
  scadCode: `/* Instant Mesh Cloning */

// markdown:tip
// **Mesh Cloning** — Wrap geometry with \`clone_ref("key")\` to register it,
// then place as many copies as you want with \`clone("key", position=[...],
// rotation=[...], scale=[...])\`. Each clone is a free Three.js transform —
// no extra WASM compilation per copy.

/* [Grid] */

// Columns
cols = 4; // [1:1:8]

// Rows
rows = 4; // [1:1:8]

// Spacing
spacing = 22; // [12:1:40]

/* [Clone Shape] */

// Shape type
shape = "bolt"; // [bolt, gem, spike]

// Shape size
size = 8; // [4:0.5:14]

// Color
// color
clone_color = [0.3, 0.6, 0.75];

/* [Variation] */

// Random rotation per clone
vary_rotation = true;

// Scale variation (±%)
scale_variance = 15; // [0:1:40]

// --- parameters end ---

$fn = 32;

// ── Define the source mesh once ──────────────────────────────────────────

color(clone_color)
clone_ref("unit")
if (shape == "bolt") {
  // Hex bolt silhouette
  union() {
    cylinder(d=size, h=size * 0.5, $fn=6, center=false);
    translate([0, 0, size * 0.5])
      cylinder(d=size * 0.55, h=size * 1.1, center=false);
  }
} else if (shape == "gem") {
  // Double-cone gem
  union() {
    cylinder(d1=0, d2=size, h=size * 0.6, center=false);
    translate([0, 0, size * 0.6])
      cylinder(d1=size, d2=0, h=size * 0.9, center=false);
  }
} else {
  // Spike — elongated cone
  cylinder(d1=size * 0.6, d2=0, h=size * 2.2, center=false);
}

// ── Place clones in a grid ────────────────────────────────────────────────

offset_x = -(cols - 1) * spacing / 2;
offset_y = -(rows - 1) * spacing / 2;

for (r = [0:rows-1], c = [0:cols-1]) {
  seed = r * 17 + c * 31;
  angle = vary_rotation ? (seed * 47) % 360 : 0;
  sv    = 1 + (scale_variance / 100) * (((seed * 13) % 100) / 100 - 0.5) * 2;
  clone("unit",
    position=[offset_x + c * spacing, offset_y + r * spacing, 0],
    rotation=[0, 0, angle],
    scale=[sv, sv, sv]
  );
}
`,
};
